import { isEmpty } from 'lodash';
import React, { Component } from 'react';
import { withRouter  } from 'react-router-dom';
import ErrorBoundary from '../utils/ErrorBoundary';

function ItemRow (props){
    const { item, filters, workingShifts } = props;
    return (
        <tr key={item.id} className="kt-datatable__row">
        <td className="kt-datatable__cell" style={{ width: '40%', minWidth: '150px' }}>
            <span>
                {item.name}
            </span>
        </td>                      
        <td className="kt-datatable__cell">
            {workingShifts 
            ? 
            <span>
                {(workingShifts.reduce((acc, el) => {
                    return acc + parseFloat(!el.articlesCashes ? 0 : el.articlesCashes.reduce((sum, article) => {
                        let check = true;

                        check = check && (article.articleId ? article.articleId === item.id : article.name === item.name);
                        if (filters && filters.typeTransaction) check = check && (article.typeTransaction === filters.typeTransaction.value);
                        if (filters && filters.typeMovementCash) check = check && (article.typeMovementCash === filters.typeMovementCash.value);
                        if(check) return sum + parseFloat(article.sum);
                        return sum;
                    }, 0))
                }, 0)).toFixed(2)}
            </span> 
            : 
            <span>0.00</span>
            }
        </td>                            
    </tr>
    );
}

class ReportWorkingShiftsTable extends Component {
    renderThead() {
        return (
            <thead className="kt-datatable__head" style={{ backgroundColor: '#f7f7f7' }}>
                <tr className="kt-datatable__row">                    
                    <th className="kt-datatable__cell" style={{ width: '40%', minWidth: '150px', paddingTop: '10px', paddingBottom: '10px' }}>
                        <span style={{ color: '#000' }}>Операция</span>
                    </th>
                    <th className="kt-datatable__cell" style={{ paddingTop: '10px', paddingBottom: '10px' }}>
                        <span style={{ color: '#000' }}>Сумма</span>
                    </th>                    
                </tr>
            </thead>
        );
    }

    getNormalizedArticles(deleted) {
        if (!deleted || deleted.length === 0) return [];
    
        const map = new Map();
    
        for (const item of deleted) {
            const { id, name, typeTransaction, typeMovementCash} = item;
            const existing = map.get(id);
    
            if (!existing) {
                map.set(id, { id, name, typeTransaction, typeMovementCash });
            } else {
                let newType = existing.typeTransaction;
                const currentType = typeTransaction;
    
                if (newType === 'all' || currentType === 'all') {
                    newType = 'all';
                } else if (newType !== currentType) {
                    newType = 'all';
                }

                map.set(id, {
                    id,
                    name: existing.name,
                    typeTransaction: newType,
                    typeMovementCash: existing.typeMovementCash,
                });
            }
        }
    
        return Array.from(map.values());
    }

    getArticles() {
        const entity = this.props.items;
        const ids = entity.map((item) => item.id);
        const deleted = (this.props.workingShifts || []).flatMap((workingShift) => {
            if (isEmpty(workingShift.articlesCashes)) return [];
            return workingShift.articlesCashes.filter((item) => item.articleId && !ids.includes(item.articleId)).map((article) => ({ id: article.articleId, name: article.name, typeMovementCash: article.typeMovementCash, typeTransaction: article.typeTransaction}));
        })
        let normalizedArticles = [];
        if (!isEmpty(deleted)) normalizedArticles = this.getNormalizedArticles(deleted);
        return [ ...entity, ...normalizedArticles];
    }
    
    renderBody(items) {        
        return (
            <tbody className="kt-datatable__body">
                {
                    items.filter((item) => {
                        let check = true;
                        if (this.props.filters && this.props.filters.article && this.props.filters.article.value) check = check && (item.id === this.props.filters.article.value);
                        return check;
                    })
                    .map((item) => (
                        <ErrorBoundary key={item.id} fallback={<tr className='kt-datatable__row'>{`Не удалось отобразить статью id: ${item.id}. Попробуйте позже.`}</tr>}>
                            <ItemRow item={item} workingShifts={this.props.workingShifts} filters={this.props.filters} />
                        </ErrorBoundary>
                    )) 
                }
            </tbody>
        );
    }

    render() {
        const items = this.getArticles()
        if (items.length === 0 || isEmpty(this.props.workingShifts)) return <div></div>
        return (
            <table className="kt-datatable__table" style={{ minHeight: '500px' }}>
                {this.renderThead()}
                {this.renderBody(items)}
            </table>
        );
    }
}

export default withRouter(ReportWorkingShiftsTable);